if (!customElements.get('collection-showcase-products')) {
  customElements.define(
    'collection-showcase-products',
    class CollectionsShowcaseProducts extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enableSlider !== 'true') {
          return;
        }

        this.initSlider();
      }

      initSlider() {
        const swiper = this.querySelector('.swiper');

        if (!swiper) {
          return;
        }

        const items = Number(this.dataset.items) || 3;

        const sliderOptions = {
          slidesPerView: items,
          spaceBetween: 8,
          breakpoints: {
            768: {
              spaceBetween: 20,
            },
          },
          threshold: 2,
        };

        if (window.FoxTheme && window.FoxTheme.Carousel) {
          this.sliderInstance = new window.FoxTheme.Carousel(
            swiper,
            sliderOptions
          );

          this.sliderInstance.init();
        }
      }
    }
  );
}

if (!customElements.get('collection-showcase')) {
  customElements.define(
    'collection-showcase',
    class CollectionsShowcase extends HTMLElement {
      connectedCallback() {
        this.tabButtons = this.querySelectorAll(
          '.collection-showcase__tab-arrow[role="tab"]'
        );

        this.tabPanels = this.querySelectorAll(
          '.collection-showcase__content[role="tabpanel"]'
        );

        this.images = this.querySelectorAll(
          '.collection-showcase__image'
        );

        this.init();
      }

      init() {
        this.tabButtons.forEach((button) => {
          button.addEventListener('focus', () => {
            const index = Number(button.dataset.index);

            this.setActiveTab(index);
          });

          button.addEventListener('click', () => {
            const index = Number(button.dataset.index);

            this.setActiveTab(index);
          });

          button.addEventListener('keydown', (event) => {
            let newIndex = null;

            const currentIndex = Number(button.dataset.index);

            if (
              event.key === 'ArrowDown' ||
              event.key === 'ArrowRight'
            ) {
              newIndex =
                (currentIndex + 1) %
                this.tabButtons.length;
            }

            if (
              event.key === 'ArrowUp' ||
              event.key === 'ArrowLeft'
            ) {
              newIndex =
                (currentIndex - 1 + this.tabButtons.length) %
                this.tabButtons.length;
            }

            if (event.key === 'Home') {
              newIndex = 0;
            }

            if (event.key === 'End') {
              newIndex = this.tabButtons.length - 1;
            }

            if (newIndex !== null) {
              event.preventDefault();

              this.tabButtons[newIndex].focus();
            }
          });
        });

        if (this.tabButtons.length) {
          this.setActiveTab(0);
        }

        if (
          window.Shopify &&
          Shopify.designMode
        ) {
          document.addEventListener(
            'shopify:block:select',
            (event) => {
              if (
                event.detail.sectionId !==
                this.dataset.sectionId
              ) {
                return;
              }

              const index = Number(
                event.target.dataset.index
              );

              if (!Number.isNaN(index)) {
                this.setActiveTab(index);
              }
            }
          );
        }
      }

      setActiveTab(index) {
        if (
          index < 0 ||
          index >= this.tabButtons.length
        ) {
          return;
        }

        this.tabButtons.forEach(
          (button, buttonIndex) => {
            const isActive =
              buttonIndex === index;

            button.setAttribute(
              'aria-selected',
              isActive
                ? 'true'
                : 'false'
            );

            button.setAttribute(
              'tabindex',
              isActive
                ? '0'
                : '-1'
            );

            button.classList.toggle(
              'active',
              isActive
            );
          }
        );

        this.tabPanels.forEach((panel) => {
          const panelIndex =
            Number(panel.dataset.index);

          const isActive =
            panelIndex === index;

          panel.hidden = !isActive;

          panel.classList.toggle(
            'active',
            isActive
          );
        });

        this.images.forEach((image) => {
          const imageIndex =
            Number(image.dataset.index);

          const isActive =
            imageIndex === index;

          image.hidden = !isActive;

          image.classList.toggle(
            'active',
            isActive
          );
        });

        const activePanel =
          this.querySelector(
            `.collection-showcase__content[data-index="${index}"]`
          );

        if (activePanel) {
          const gridList =
            activePanel.querySelector(
              'grid-list'
            );

          if (
            gridList &&
            typeof gridList.showGridItems ===
              'function'
          ) {
            gridList.showGridItems();
          }

          const motion =
            activePanel.querySelector(
              'motion-element'
            );

          if (
            motion &&
            typeof motion.refreshAnimation ===
              'function'
          ) {
            motion.refreshAnimation();
          }
        }
      }
    }
  );
}